import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=025b2c7c&"
import script from "./AlertMessage.vue?vue&type=script&lang=js&"
export * from "./AlertMessage.vue?vue&type=script&lang=js&"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports